'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = require('../../../../');

exports.default = {
  content: {
    items: [_.ImagePanel.defaultProps, _.ImagePanel.defaultProps]
  },
  config: {
    id: 'device-panels',
    theme: 'theme-background-color-blue-alt',
    deviceImage: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/emea/gb/en/misc/right_image.png',
    backgroundImage: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/pages/paypal-me/left-image.png',
    deviceImagePosition: 'right',
    columns: 2
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/device-panels/props/default.js
// module id = 1080
// module chunks = 4